import React from "react"
import { useLocation } from "react-router-dom";
import { ViewComponentProps, withView } from "../shared/viewcomponent"

export const NoMatchComponent = withView(function (props: ViewComponentProps) {
    let location = useLocation();
    props.setTitle(`Page not found ${location.pathname}`);
    return <>
        <h3>Page not found <code>{location.pathname}</code></h3>
    </>
});